import React, { Fragment } from 'react'

import { defaultsWereChanged, getMarkedCookieValue } from 'utils'

import TryError from '../TryError'

class Results extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            token: getMarkedCookieValue('UAT'),
        }
    }

    render() {
        const { token } = this.state
        const {
            slug,
            provider,
            output,
            error,
            capabilities,
            languages = [],
        } = this.props

        if (error) {
            return <TryError error={error} provider={provider} />
        }

        const defaultsAreChanged = defaultsWereChanged(slug, capabilities)

        if (defaultsAreChanged && !token) {
            return null
        }

        let res = <div className="try-intento__input-control">{output}</div>

        if (slug === 'ai/image/tagging' && Array.isArray(output)) {
            output.sort((a, b) => b.tagging_score - a.tagging_score)
            res = (
                <div className="try-intento__input-control try-intento__input-tags">
                    {output.map(item =>
                        this.renderTag({
                            score: item.tagging_score,
                            label: item.tagging_label,
                        })
                    )}
                </div>
            )
        }

        if (slug === 'ai/text/detect-language' && Array.isArray(output)) {
            const labelGetter = label => {
                const [currentLanguage] = languages.filter(
                    lang => lang.intento_code === label
                )
                if (currentLanguage) {
                    return currentLanguage.iso_name
                }
                return label
            }
            if (Array.isArray(output[0])) {
                res = (
                    <Fragment>
                        {output.map((outputElement, idxE) => {
                            outputElement.sort(
                                (a, b) => b.confidence - a.confidence
                            )
                            return (
                                <div
                                    key={idxE}
                                    className="try-intento__input-control try-intento__input-tags"
                                >
                                    {outputElement.map(item =>
                                        this.renderTag({
                                            score: item.confidence,
                                            label: item.language,
                                            labelGetter,
                                        })
                                    )}
                                </div>
                            )
                        })}
                    </Fragment>
                )
            } else {
                res = (
                    <div className="try-intento__input-control try-intento__input-tags">
                        {output.map(item =>
                            this.renderTag({
                                score: item.score,
                                label: item.language,
                                labelGetter,
                            })
                        )}
                    </div>
                )
            }
        }

        return res
    }

    renderTag = ({ score, label, labelGetter }) => (
        <div className="try-intento__tag-wrap" key={label}>
            <div
                className="try-intento__tag"
                style={{
                    width: `${100 * score}%`,
                }}
            >
                {typeof labelGetter === 'function' ? labelGetter(label) : label}
                <span className="try-intento__tag-value">
                    &nbsp;{(100 * score).toFixed(2)}%
                </span>
            </div>
        </div>
    )
}

export default Results



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/TryAnyIntent/Results.jsx